
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/buyer-rental-agreement",
      function () {
        return require("private-next-pages/info/buyer-rental-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/buyer-rental-agreement"])
      });
    }
  